import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'AccountEntryExportFormat';
const ENDPOINT = `/account-entry-export-formats/`;

@Injectable({
    providedIn: 'root'
})
export class AccountEntryExportFormatService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
